import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { JoveButton, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Box, Typography } from '@mui/material';
import { apiJoveForgotPassword } from 'libs/uikit/src/api/combineApi';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { useFormContext } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { validateIsEmail } from '../../../../utils/formatValidate';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ForgotPasswordForm = function ForgotPasswordForm(props) {
  var onSend = props.onSend,
      onBackToLogin = props.onBackToLogin;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState(false),
      submitting = _useState[0],
      setSubmitting = _useState[1];

  var _useState2 = useState(false),
      sent = _useState2[0],
      setSent = _useState2[1];

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      handleSubmit = _useFormContext.handleSubmit;
  /**
   * request
   */


  var requestForgotPasswordEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getValues, email, slug, params, _yield$apiJoveForgotP, _yield$apiJoveForgotP2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getValues = getValues(), email = _getValues.email, slug = _getValues.slug;
              params = {
                email: email,
                slug: slug
              };
              setSubmitting(true);
              _context.next = 5;
              return apiJoveForgotPassword(params);

            case 5:
              _yield$apiJoveForgotP = _context.sent;
              _yield$apiJoveForgotP2 = _slicedToArray(_yield$apiJoveForgotP, 1);
              res = _yield$apiJoveForgotP2[0];
              setSubmitting(false);

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                toast === null || toast === void 0 ? void 0 : toast.success($t('text:login.email_sent'));
                setSent(true);
                onSend === null || onSend === void 0 ? void 0 : onSend();
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestForgotPasswordEmail() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var continueAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              handleSubmit(requestForgotPasswordEmail)();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function continueAction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var backToLoginAction = function backToLoginAction() {
    onBackToLogin === null || onBackToLogin === void 0 ? void 0 : onBackToLogin();
  };

  var validateEmail = function validateEmail(value) {
    return validateIsEmail(value) ? true : $t('text:login.valid_email');
  };

  return /*#__PURE__*/_jsxs(Box, {
    component: "form",
    noValidate: true,
    autoComplete: "on",
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-2",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: $t('text:login.forgot_your_password')
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-gray-600",
        children: $t('text:login.forgot_password_hint')
      })]
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "email",
      control: control,
      rules: {
        validate: validateEmail
      },
      autoFocus: true,
      autoComplete: "email",
      label: $t('text:login.email_label'),
      placeholder: $t('text:login.email_placeholder')
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center space-y-6",
      children: [sent ? /*#__PURE__*/_jsx(Typography, {
        className: "rounded-xl bg-gray-50 px-4 py-3 text-sm leading-6 text-gray-600",
        children: $t('text:login.reset_link_sent', {
          email: getValues('email')
        })
      }) : /*#__PURE__*/_jsx(JoveButton, {
        variant: "contained",
        color: "primary",
        size: "large",
        loading: submitting,
        className: "w-full",
        onClick: continueAction,
        children: $t('text:login.send')
      }), /*#__PURE__*/_jsx(Typography, {
        component: "button",
        type: "button",
        className: "cursor-pointer text-sm font-semibold text-[#CD0D47] hover:underline",
        onClick: backToLoginAction,
        children: $t('text:login.back_to_login')
      })]
    })]
  });
};

export default ForgotPasswordForm;